import { createApp } from 'vue'
import App from './App.vue'
import router from './router'

// Include a collection of AA site styles to bring app dev closer to
// Drupal context.
if (process.env.NODE_ENV === 'development') {
  require('../../../aa_ui/css/variables.css');
  require('../../../aa_ui/bootstrap/css/styles.css');
  require('../../../aa_ui/css/text.css');
  require('../../../aa_ui/css/page--global.css');
  require('../../../aa_ui/css/utility.css');
  require('../../../aa_ui/bootstrap/js/bootstrap.bundle');
  require('../../css/aa-faq.css');
  require('../../../../../themes/contrib/gin/dist/css/theme/font.css');
  require('../../../../../themes/contrib/gin/dist/css/theme/variables.css');
  require('../../../../../themes/contrib/gin/dist/css/theme/accent.css');
  require('../../../../../themes/contrib/gin/dist/css/base/gin.css');
  require('../../../../../themes/custom/aa_theme/css/style.css');
  require('./aa-app-dev.css');
  require('../../../../../libraries/fontawesome/js/fontawesome.min.js');
  require('../../../../../libraries/fontawesome/js/solid.min.js');
  require('../../../../../libraries/fontawesome/js/regular.min.js');
}

createApp(App).use(router).mount('#aa-faq')
